import React, { createContext, useContext, useEffect, useState } from "react";
import { ConsultationDetails } from "../libs/types";
import { createDebugSetter } from "../utils/debugHelpers";
import { sessionStore } from "../utils/sessionStore";
import { safeStorage } from "../utils/safeStorage";
import { safeObject } from "../utils/funcs";

type ConsultationContextType = {
  state: ConsultationDetails | undefined;
  setState: (newValue: ConsultationDetails) => void;
};

const initialState = sessionStore.getConsultationInfo();

const ConsultationContext = createContext<ConsultationContextType | null>(null);

export const ConsultationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, setState] = useState<ConsultationDetails>(
    safeObject<ConsultationDetails>(initialState)
  );

  // Use debug setter
  const setConsultationDebug = createDebugSetter(
    "ConsultationContext updated",
    setState
  );

  useEffect(() => {
    if (state) {
      sessionStore.setConsultationInfo(state);
    }
  }, [state]);

  return (
    <ConsultationContext.Provider
      value={{ state, setState: setConsultationDebug }}
    >
      {children}
    </ConsultationContext.Provider>
  );
};

export const useConsultationContext = () => {
  const context = useContext(ConsultationContext);
  return context?.state;
};

export const useConsultationDispatch = () => {
  const context = useContext(ConsultationContext);
  if (context?.setState) return context?.setState;

  return (data: ConsultationDetails) => {
    safeStorage.setSessionItem("consultationDetails", JSON.stringify(data));
  };
};
